import styled from "styled-components"
import Overlay from "../../../Componentes/Overlay"
import Modal from "../../../Componentes/Utils/Modal"
import { useState } from "react"
import useApi from "../../../hooks/useApi"

const Header = styled.div`
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
`
const MainTxt = styled.p`
    font-size: 15px;
    font-weight: 500;
    margin: 0;
    color: #333;
`
const Body = styled.div`
    padding: 15px;
    box-sizing: border-box;
`
const SubTxt = styled.p`
    font-size: 13px;
    color: #555;
    margin: 0 0 20px 0;
`
const ContainerBtn = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`
const Btn = styled.button`
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    background-color: ${props => props.cancel ? '#888' : '#d9534f'};
    transition: background-color 0.3s;

    &:hover {
        background-color: ${props => props.cancel ? '#777' : '#c9302c'};
    }
`

const ModalDelete = ({ treinamento, fecharModal, atualizarLista }) => {

    const api = useApi();

    const [ loading, setLoading ] = useState( false );

    const handleDelete = async () => {

        setLoading( true );

        try{

            const { data } = await api.post('/Painel/API/Treinamentos/DeleteCronogram/', {
                id: treinamento.id
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            console.log( data );
            fecharModal();
            atualizarLista();

        }catch( e ){

            console.log( e )

        }finally{

            setLoading( false );

        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="sm" noPadding >
                    <Header>
                        <MainTxt>Cancelar Treinamento</MainTxt>
                    </Header>
                    <Body>
                        <SubTxt>Tem certeza que deseja cancelar o treinamento "{treinamento.treinamento}" do colaborador "{treinamento.colaborador}"?</SubTxt>
                        <ContainerBtn>
                            <Btn disabled={loading} cancel onClick={fecharModal} >Cancelar</Btn>
                            <Btn disabled={loading} onClick={handleDelete} >
                                { loading ? 'Excluindo...' : 'Excluir' }
                            </Btn>
                        </ContainerBtn>
                    </Body>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalDelete;